import styled from 'styled-components';
import React from 'react';
import Small from '../../typography/Small';
import { colors, fontSizes, opacities } from '../../../defaultTheme';
export const COMPONENT_HEIGHT = 48;
export const CONTAINER_HEIGHT = 275;
export const FieldWrapper = styled.div `
  width: 100%;
`;
export const NativeSelectContainer = styled.select `
  display: none;
`;
export const SelectOuterWrapper = styled.div `
  position: relative;
  box-sizing: border-box;
  font-family: inherit;
`;
export const SelectInnerWrapper = styled.div `
  font-size: inherit;
  color: ${({ error }) => (error ? colors.error : colors.mediumGrey)};
  width: 100%;
  height: ${COMPONENT_HEIGHT}px;
  position: relative;
  border-radius: 6px;
  ${({ isMenuOpen, placement }) => isMenuOpen &&
    `
      border-${placement === 'TOP' ? 'top' : 'bottom'}-right-radius: 0;
      border-${placement === 'TOP' ? 'top' : 'bottom'}-left-radius: 0;
    `}
  box-shadow: 0 0 0 ${({ error }) => error ? `2px ${colors.error};` : `1px ${colors.heavyGrey};`};
  display: flex;
  border: none;
  align-items: center;
  flex-wrap: wrap;
  &:hover {
    ${({ error, isDisabled }) => error || isDisabled ? '' : `box-shadow: 0 0 0 2px ${colors.heavyGrey};`}
    cursor: normal;
  }
  background-color: ${({ isDisabled }) => isDisabled ? colors.lightestGrey : colors.white};

  &:focus-within {
    ${({ isDisabled, theme }) => isDisabled
    ? ''
    : `
        box-shadow: 0 0 0 2px ${theme.field.focus};
        color: ${colors.heavyGrey};
      `}
  }
  transition: all 100ms ease 0s;
  outline: 0px !important;
  justify-content: space-between;
  cursor: default;
`;
export const Label = styled.label `
  font-size: ${fontSizes.small}px;
  left: ${({ hasIcon }) => (hasIcon ? '48px' : '16px')};
  opacity: 0;
  left: 0;
  top: 3px;
  transition-property: opacity;
  transition-duration: 0.2s;
  position: absolute;
  color: ${({ error, isMenuOpen, isDisabled, theme }) => {
    if (error && !isMenuOpen)
        return `${colors.error};`;
    if (!isDisabled)
        return `${theme.field.label};`;
    return `${colors.mediumGrey};`;
}};

  ${({ animateLabel, isMenuOpen, hasSelection }) => (animateLabel && isMenuOpen) || hasSelection ? 'opacity: 1;' : ''}
`;
export const SelectedPlaceholder = styled.span `
  position: absolute;
  left: 0;
  bottom: 13px;
  transition-property: bottom;
  transition-duration: 0.2s;
  color: ${({ hasSelection }) => {
    return hasSelection ? colors.black : colors.mediumGrey;
}};

  ${({ animateLabel, isMenuOpen, hasSelection }) => (animateLabel && isMenuOpen) || hasSelection ? 'bottom: 5px;' : ''}
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const SelectValueWrapper = styled.div `
  font-size: inherit;
  height: 100%;
  display: flex;
  align-items: center;
  color: ${colors.mediumGrey};
  flex-wrap: wrap;
  position: relative;
  box-sizing: border-box;
  flex: 1 1 0%;
  padding: 0px 16px;
  padding-left: ${({ hasIcon }) => (hasIcon ? '0' : '16px')};
  overflow: hidden;
`;
export const Placeholder = styled.div `
  font-family: 'Open Sans';
  font-size: inherit;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  color: ${colors.mediumGrey};
  margin-right: 2px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  box-sizing: border-box;
  user-select: none;
`;
export const SelectInputWrapper = styled.div `
  padding-bottom: 2px;
  padding-top: 2px;
  visibility: visible;
  color: ${colors.black};
  box-sizing: border-box;
  margin: 2px;
`;
export const SelectInput = styled.div `
  box-sizing: content-box;
  width: 2px;
  background: 0px center;
  border: 0px;
  font-size: inherit;
  opacity: 1;
  outline: 0px;
  padding: 0px;
  color: inherit;
`;
export const RightIconWrapper = styled.div `
  font-size: 20px;
  display: flex;
  box-sizing: border-box;
  padding: 0 16px;
  transition: color 150ms ease 0s;
  color: ${colors.mediumGrey};
`;
/**
 * Apply bottom borders with 0 radius and top borders to 4 radius when placement is TOP
 * Apply bottom borders with 4 radius and top borders to 0 radius when placement is BOTTOM
 * @param {string} position
 */
const getBorderStyles = (position) => {
    return position === 'TOP'
        ? `
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  `
        : `
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  `;
};
export const OptionsMenuWrapper = styled.div `
  background-color: ${colors.white};
  box-shadow: ${({ error }) => error
    ? `0 0 0 2px ${colors.error};`
    : `0 1px 10px 0 ${opacities.rgbaLight10}, 0 4px 5px 0 ${opacities.rgbaLight08}, 0 2px 4px 0 ${opacities.rgbaLight04}`};
  border: 1px solid ${colors.heavyGrey};
  ${({ placement }) => getBorderStyles(placement)}
  position: absolute;
  z-index: 1;
  box-sizing: border-box;
  width: calc(100% + 2px);
  margin-left: -1px;
  ${({ placement }) => (placement === 'TOP' ? 'bottom: 49px;' : '')}
`;
export const OptionsMenuInnerWrapper = styled.ul `
  overflow-y: auto;
  position: relative;
  padding: unset;
  margin: unset;
  box-sizing: border-box;
  max-height: ${CONTAINER_HEIGHT}px;
`;
export const OptionWrapper = styled.li `
  display: flex;
  align-items: center;
  padding-left: ${({ hasIcon }) => (hasIcon ? '0' : '16px')};
  background-color: ${({ selected, theme }) => selected ? theme.hoverBackground : 'transparent'};
  outline: ${({ focused }) => (focused ? 'auto' : 'none')};
  border-bottom: solid 1px ${colors.heavyGrey};
  min-height: ${COMPONENT_HEIGHT}px;
  font-weight: ${({ selected }) => (selected ? 'bold' : 'regular')};
  &:hover {
    background-color: ${({ theme }) => theme.hoverBackground};
  }
  &:last-of-type {
    border-bottom: none;
  }
`;
export const Option = styled.div `
  color: inherit;
  cursor: default;
  display: block;
  font-size: inherit;
  width: 100%;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  box-sizing: border-box;
`;
export const ErrorIconWrapper = styled.div `
  height: 100%;
  margin-right: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const HelpText = styled(Small) `
  display: block;
  padding: 5px 0px;
  flex-basis: 100%;
  color: ${({ error }) => (error ? colors.error : colors.mediumGrey)};
`;
export const HelpTextWrapper = styled.div `
  display: flex;
  color: ${({ error }) => (error ? colors.error : colors.mediumGrey)};
  align-items: center;
`;
export const LeftIconWrapper = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 44px;
  width: 44px;
  color: ${({ error, isMenuOpen, theme, isDisabled }) => {
    if (error && !isMenuOpen)
        return `${colors.error};`;
    if (!isDisabled)
        return `${theme.field.icon};`;
    return `${colors.mediumGrey};`;
}};
`;
export const HelpAndError = ({ error, helpText, id, errorIcon }) => {
    return (React.createElement(React.Fragment, null,
        error && React.createElement(ErrorIconWrapper, null, errorIcon),
        React.createElement(HelpText, { id: `syf-help-text-${id}`, error: error }, error || helpText)));
};
export const NativeSelect = ({ id, name, required, tabIndex, options, selectedOption, error, onChange, nativeSelectRef, dataCy }) => {
    return (React.createElement(NativeSelectContainer, { id: `${id}-native`, ref: nativeSelectRef, "aria-describedby": `syf-help-text-${id}`, "aria-invalid": !!error, value: selectedOption && selectedOption.value, name: name, onChange: () => onChange(selectedOption), required: required, tabIndex: tabIndex, "data-cy": dataCy && `${dataCy}.select` }, options.map((option, index) => (React.createElement("option", { value: option.value, key: `${index + 1}` }, option.label)))));
};
export const SelectValue = ({ leftIcon, hasSelection, isMenuOpen, isDisabled, error, dataCy, placeholder, selectedOptionLabel, animateLabel, id, name, rightIconOpen, rightIconClosed }) => {
    const RightIcon = () => {
        if (isDisabled)
            return null;
        return (React.createElement(RightIconWrapper, { "aria-hidden": "true" }, isMenuOpen ? rightIconOpen : rightIconClosed));
    };
    return (React.createElement(React.Fragment, null,
        leftIcon && (React.createElement(LeftIconWrapper, { error: error, isMenuOpen: isMenuOpen, isDisabled: isDisabled }, leftIcon)),
        React.createElement(SelectValueWrapper, { hasIcon: !!leftIcon },
            React.createElement(Placeholder, null,
                React.createElement(Label, { hasSelection: hasSelection, animateLabel: animateLabel, isMenuOpen: isMenuOpen, htmlFor: `${id}-native`, error: error, isDisabled: isDisabled, id: `${id}-label`, "data-cy": dataCy && `${dataCy}.label` }, placeholder),
                React.createElement(SelectedPlaceholder, { hasSelection: hasSelection, animateLabel: animateLabel, isMenuOpen: isMenuOpen, error: error, "data-cy": dataCy && `${dataCy}.selection` }, selectedOptionLabel)),
            React.createElement(SelectInputWrapper, null,
                React.createElement(SelectInput, { id: id, name: name }))),
        React.createElement(RightIcon, null)));
};
